import React, { useCallback, useEffect } from "react"
import { ApolloProvider } from "@apollo/client/react/context/ApolloProvider"
import { ErrorLink } from "@apollo/client/link/error"
import { ServerError } from "@apollo/client/link/utils/throwServerError"

import { apolloClient } from "../apolloClient"

import { useAuthenticationContext } from "./AuthenticationContext"

export const AuthenticatedApolloProvider: React.FC = ({ children }) => {
	const { logout } = useAuthenticationContext()
	const errorHandler = useCallback<ErrorLink.ErrorHandler>(
		(error) => {
			const { networkError } = error

			if (!networkError) {
				return
			}

			// life can be hard sometimes...
			const serverError: ServerError = networkError as ServerError

			if (serverError.statusCode !== 401) {
				return
			}

			// logout if server threw unauthenticated error
			logout()
		},
		[logout]
	)

	useEffect(() => {
		apolloClient.setLink(
			new ErrorLink(errorHandler).concat(apolloClient.link)
		)
	}, [errorHandler])

	return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
}
